// this file must be imported before TinyMCE can be used

// sets up skins and default css so they can be imported
// ! prefix is important; stops other loaders from running and trying to replace files with JS to load from cache
require.context(
    '!file-loader?name=/tinymce/[path]/[name].[ext]&context=node_modules/tinymce!tinymce/skins',
    true,
    /.*/
);
require.context(
    '!file-loader?name=/tinymce/default/[name].[ext]&context=node_modules/tinymce!tinymce/skins/content/default',
    true,
    /.*/
);
import 'tinymce';
import 'tinymce/themes/silver';

// Any plugins we use must be imported here
import 'tinymce/plugins/code';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/table';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/help';
import 'tinymce/plugins/wordcount';

export default {
    skinsDirectory: '/tinymce/skins/ui/oxide/',
    contentCssPath: '/tinymce/default/content.min.css',
    // all plugins listed here must be imported above
    importedPlugins: [
        'code advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'
    ]
};
